module.exports = __webpack_public_path__ + "staticcomp/img/share.ba86c24.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/11/share.jpg
// module id = Pyru
// module chunks = 39